'use client'
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { MenuIcon, X } from 'lucide-react';
import { useTranslations } from "next-intl";
import { useTheme } from "next-themes";
import Link from "next/link";
import { useEffect, useState } from 'react';
import LanguageSwitcher from "../language-switcher";
import Logo from "../logo";
import ThemeSwitcher from "../theme-switcher";
const Navbar = () => {
      const { theme } = useTheme();
      const t = useTranslations('landing.navbar');
      const [isScrolled, setIsScrolled] = useState(false);
      const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

      useEffect(() => {
            const handleScroll = () => {
                  const offset = window.scrollY;
                  setIsScrolled(offset > 50);
            };

            window.addEventListener('scroll', handleScroll);
            return () => window.removeEventListener('scroll', handleScroll);
      }, []);

      return (
            <header className={cn(
                  "fixed top-0 left-0 right-0 z-50 transition-all duration-300",
                  isScrolled ? "bg-white/80 dark:bg-gray-900/80 backdrop-blur-lg shadow-sm py-3" : "bg-transparent py-5"
            )}>
                  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex items-center justify-between">
                              <div className="flex items-center">
                                    <Link href="/" className="flex items-center space-x-2">
                                          <Logo width={100} height={50} />
                                          {/* <Image src={theme !== 'dark' ? "/logo/logo_light.png" : "/logo/logo_dark.png"} alt="Kiwilog" width={100} height={50} /> */}
                                          {/* <span className={cn(
                                                "font-semibold text-xl transition-colors",
                                                isScrolled ? "text-gray-800" : "text-gray-900"
                                          )}>
                                                UpdateHub
                                          </span> */}
                                    </Link>
                              </div>

                              {/* Desktop Navigation */}
                              <nav className="hidden md:flex items-center space-x-8">
                                    <Link href="/#features" className="link-hover text-sm font-medium text-gray-700 dark:text-gray-400 hover:text-gray-900 transition-colors">
                                          {t('features')}
                                    </Link>
                                    <Link href="/#widget" className="link-hover text-sm font-medium text-gray-700 dark:text-gray-400 hover:text-gray-900 transition-colors">
                                          {t('widget')}
                                    </Link>
                                    <Link href="/#pricing" className="link-hover text-sm font-medium text-gray-700 dark:text-gray-400 hover:text-gray-900 transition-colors">
                                          {t('pricing')}
                                    </Link>
                                    <div className="flex items-center space-x-2">
                                          <ThemeSwitcher />
                                          <LanguageSwitcher />
                                          <Link href="/auth/signin">
                                                <Button variant="outline" className="w-full">
                                                      {t('login')}
                                                </Button>
                                          </Link>
                                          <Link href="/auth/signin">
                                                <Button className="w-full bg-kiwilog hover:bg-primary-600">
                                                      {t('start_for_free')}
                                                </Button>
                                          </Link>
                                    </div>
                              </nav>

                              {/* Mobile Menu Button */}
                              <div className="md:hidden">
                                    <Button
                                          variant="ghost"
                                          className="text-gray-700"
                                          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                                    >
                                          {mobileMenuOpen ? <X size={20} /> : <MenuIcon size={20} />}
                                    </Button>
                              </div>
                        </div>

                        {/* Mobile Navigation */}
                        {mobileMenuOpen && (
                              <div className="md:hidden pt-4 pb-3 animate-fade-in">
                                    <div className="flex flex-col space-y-4">
                                          <a
                                                href="#features"
                                                className="text-base font-medium text-gray-900 dark:text-gray-400 hover:text-kiwilog transition-colors px-3 py-2 rounded-md hover:bg-gray-100"
                                                onClick={() => setMobileMenuOpen(false)}
                                          >
                                                {t('features')}
                                          </a>
                                          <a
                                                href="#widget"
                                                className="text-base font-medium text-gray-900 dark:text-gray-400 hover:text-kiwilog transition-colors px-3 py-2 rounded-md hover:bg-gray-100"
                                                onClick={() => setMobileMenuOpen(false)}
                                          >
                                                {t('widget')}
                                          </a>
                                          <a
                                                href="#pricing"
                                                className="text-base font-medium text-gray-900 dark:text-gray-400 hover:text-kiwilog transition-colors px-3 py-2 rounded-md hover:bg-gray-100"
                                                onClick={() => setMobileMenuOpen(false)}
                                          >
                                                {t('pricing')}
                                          </a>
                                          <div className="pt-2 flex flex-col space-y-3">
                                                <Link href="/auth/signin">
                                                      <Button variant="outline" className="w-full">
                                                            {t('login')}
                                                      </Button>
                                                </Link>
                                                <Link href="/auth/signin">
                                                      <Button className="w-full bg-kiwilog hover:bg-primary-600">
                                                            {t('start_for_free')}
                                                      </Button>
                                                </Link>
                                          </div>
                                    </div>
                              </div>
                        )}
                  </div>
            </header>
      );
};

export default Navbar;